import { useState, useEffect } from 'react';
import apiClient from '@/libs/api';
import dayjs from 'dayjs';
import timezone from "dayjs/plugin/timezone.js";
import utc from "dayjs/plugin/utc.js";
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.tz.setDefault("Asia/Taipei");


const useFeatureFlags = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [serverDate, setServerDate] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    getServerDate();
  }, []);

  const getServerDate = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const result = await apiClient.getServerTime();
      
      // Parse the Firestore Timestamp object
      let date;
      if (result.milliseconds) {
        date = dayjs(result.milliseconds);
      } else if (result.timestamp && result.timestamp._seconds) {
        date = dayjs(result.timestamp._seconds * 1000);
      } else if (result.timestamp) {
        date = dayjs(result.timestamp);
      } else {
        date = dayjs(); // Fallback to local date
      }
      
      setServerDate(date);
    } catch (err) {
      console.error('Error getting server date for feature flags:', err);
      setError(err);
      setServerDate(dayjs()); // Fallback to local date
    } finally {
      setIsLoading(false);
    }
  };

  // Feature flags based on server date
  const isVIPEnrollmentEnabled = () => {
    // Default to disabled for safety - only enable if we have server date and it's before cutoff
    if (!serverDate || error || isLoading) return false;
    return serverDate.isBefore(dayjs.tz('2025-09-01','Asia/Taipei'));
  };

  return {
    isLoading,
    error,
    serverDate,
    isVIPEnrollmentEnabled: isVIPEnrollmentEnabled(),
    refreshServerDate: getServerDate
  };
};

export default useFeatureFlags;
